import { render, staticRenderFns } from "./os.vue?vue&type=template&id=9bc6ec30&scoped=true&"
import script from "./os.vue?vue&type=script&lang=js&"
export * from "./os.vue?vue&type=script&lang=js&"
import style0 from "./os.vue?vue&type=style&index=0&id=9bc6ec30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc6ec30",
  null
  
)

export default component.exports